import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles.css';

// autoUpdate keeps the installed app fresh; the SW also carries the push/notification
// handlers the background-alert seam needs.
registerSW({ immediate: true });

const el = document.getElementById('root');
if (el) {
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
